import { gql } from '@apollo/client'

export const RECORD_RES_CENTER_MIGRATION_LEARN_MORE = gql`
  mutation RecordResCenterMigrationLearnMore {
    recordResCenterMigrationLearnMore {
      eligible
      help_article_url
      res_center_url
      forgot_password_url
      learn_more_clicked_at
      try_it_attempted_at
      try_it_succeeded_at
    }
  }
`

export const TRY_RES_CENTER_MIGRATION = gql`
  mutation TryResCenterMigration {
    tryResCenterMigration {
      status
      succeeded
      state {
        eligible
        help_article_url
        res_center_url
        forgot_password_url
        learn_more_clicked_at
        try_it_attempted_at
        try_it_succeeded_at
      }
    }
  }
`
